export default __webpack_public_path__ + "media/storefront/features/hymns/hymns/Ukraine-39882bead8f683987b3a7fe3810aa11b.mp3";